import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBolt, faExclamationTriangle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-simulation-model-actions',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './simulation-model-actions.component.html',
  styleUrls: ['./simulation-model-actions.component.scss'],
})
export class SimulationModelActionsComponent {
  @Input() modelName = '';
  @Input() nameLabelKey = 'INTERACTION_MODEL_EDITOR.NEW_MODEL_NAME';
  @Input() namePlaceholderKey = '';
  @Input() saveLabelKey = 'INTERACTION_MODEL_EDITOR.SAVE';
  @Input() executeLabelKey = 'INTERACTION_MODEL_EDITOR.EXECUTE';
  @Input() saveAndExecuteLabelKey = 'INTERACTION_MODEL_EDITOR.SAVE_AND_EXECUTE';
  @Input() showExecute = true;
  @Input() showSaveAndExecute = false;
  @Input() showWarning = false;
  @Input() warningLabelKey = 'INTERACTION_MODEL_EDITOR.NO_ARCHIVES_WARNING';
  @Input() hasChanges = false;
  @Input() markSaveChanges = false;
  @Input() saveDisabled = false;
  @Input() executeDisabled = false;
  @Input() saving = false;
  @Input() executing = false;
  @Output() modelNameChange = new EventEmitter<string>();
  @Output() save = new EventEmitter<void>();
  @Output() saveAndExecute = new EventEmitter<void>();
  @Output() execute = new EventEmitter<void>();

  readonly icons = { faBolt, faExclamationTriangle, faSpinner };
}
